module.exports = __webpack_public_path__ + "static/media/H16.4ad1e2ef.png";